"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _Actions = require("./Actions");

var _topicService = require("@insided/shared/services/topicService");

var _contentType = require("@insided/shared/utils/contentType");

var _common = require("@insided/shared/utils/common");

var _likeStateUtils = require("../../likeStateUtils");

var _Comment = _interopRequireDefault(require("@insided/destination/icons/Comment"));

var _TopLikedBy = _interopRequireDefault(require("../../TopLikedBy"));

var _SubtleButton = _interopRequireDefault(require("@insided/shared/uikit/SubtleButton"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ExpandCircle = _interopRequireDefault(require("@insided/shared/icons/ExpandCircle"));

var _ExpandCircleUp = _interopRequireDefault(require("@insided/shared/icons/ExpandCircleUp"));

var _ThumbUp = _interopRequireDefault(require("@insided/destination/icons/ThumbUp"));

var _Upvote = _interopRequireDefault(require("@insided/destination/icons/Upvote"));

var _CheckInCircleOff = _interopRequireDefault(require("@insided/destination/icons/CheckInCircleOff"));

var _CheckInCircle = _interopRequireDefault(require("@insided/destination/icons/CheckInCircle"));

var _actionService = require("../../services/actionService");

var _topicService2 = require("../../services/topicService");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicFooter = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicFooter, _Component);

  var _super = _createSuper(TopicFooter);

  function TopicFooter() {
    var _this$props$topLikedB;

    var _this;

    (0, _classCallCheck2.default)(this, TopicFooter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      hasCurrentUserLiked: _this.props.currentUser.id !== null && _this.props.likedBy.includes(_this.props.currentUser.id.toString()),
      likedBy: _this.props.likedBy,
      topLikedBy: (_this$props$topLikedB = _this.props.topLikedBy) !== null && _this$props$topLikedB !== void 0 ? _this$props$topLikedB : []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "likePending", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onLikeClick", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e, isGuestUser) {
        var newIsLiked;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();

                if (!isGuestUser) {
                  _context.next = 4;
                  break;
                }

                TopicFooter.showLoginModal(e);
                return _context.abrupt("return");

              case 4:
                if (!_this.likePending) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                _this.likePending = true;
                newIsLiked = !_this.state.hasCurrentUserLiked;

                _this.updateLikeState(newIsLiked);

                _context.prev = 9;
                _context.next = 12;
                return _this.handleLikeRequest(newIsLiked);

              case 12:
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](9);

                _this.updateLikeState(!newIsLiked);

              case 17:
                _context.prev = 17;
                _this.likePending = false;
                return _context.finish(17);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[9, 14, 17, 20]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(TopicFooter, [{
    key: "handleLikeRequest",
    value: function () {
      var _handleLikeRequest = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(newLikeState) {
        var _this$props, contentType, privateReplyId, privateId, currentUser, userId, consistentContentType, isIdeaContent;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props = this.props, contentType = _this$props.contentType, privateReplyId = _this$props.privateReplyId, privateId = _this$props.privateId, currentUser = _this$props.currentUser;
                userId = Number(currentUser.id);
                consistentContentType = (0, _contentType.getConsistentContentType)(contentType);
                isIdeaContent = (0, _contentType.isIdea)(contentType);

                if (!privateReplyId) {
                  _context2.next = 16;
                  break;
                }

                if (!newLikeState) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 8;
                return (0, _topicService.likeReply)(consistentContentType, privateReplyId, userId);

              case 8:
                return _context2.abrupt("return", _context2.sent);

              case 11:
                _context2.next = 13;
                return (0, _topicService.unlikeReply)(consistentContentType, privateReplyId, userId);

              case 13:
                return _context2.abrupt("return", _context2.sent);

              case 14:
                _context2.next = 37;
                break;

              case 16:
                if (!isIdeaContent) {
                  _context2.next = 28;
                  break;
                }

                if (!newLikeState) {
                  _context2.next = 23;
                  break;
                }

                _context2.next = 20;
                return (0, _topicService2.voteIdea)(String(privateId), String(userId));

              case 20:
                return _context2.abrupt("return", _context2.sent);

              case 23:
                _context2.next = 25;
                return (0, _topicService2.unvoteIdea)(String(privateId), String(userId));

              case 25:
                return _context2.abrupt("return", _context2.sent);

              case 26:
                _context2.next = 37;
                break;

              case 28:
                if (!newLikeState) {
                  _context2.next = 34;
                  break;
                }

                _context2.next = 31;
                return (0, _topicService.like)(consistentContentType, privateId, userId);

              case 31:
                return _context2.abrupt("return", _context2.sent);

              case 34:
                _context2.next = 36;
                return (0, _topicService.unlike)(consistentContentType, privateId, userId);

              case 36:
                return _context2.abrupt("return", _context2.sent);

              case 37:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleLikeRequest(_x3) {
        return _handleLikeRequest.apply(this, arguments);
      }

      return handleLikeRequest;
    }()
  }, {
    key: "updateLikeState",
    value: function updateLikeState(hasCurrentUserLiked) {
      var _currentUser$id;

      var _this$props2 = this.props,
          currentUser = _this$props2.currentUser,
          privateReplyId = _this$props2.privateReplyId,
          onLikeUpdate = _this$props2.onLikeUpdate;
      var currentUserIdStr = (_currentUser$id = currentUser.id) === null || _currentUser$id === void 0 ? void 0 : _currentUser$id.toString();

      if (!currentUserIdStr) {
        this.setState({
          hasCurrentUserLiked: hasCurrentUserLiked
        });
        window.app.events.commands.execute("post:like:".concat(privateReplyId), {
          currentUserHasLiked: hasCurrentUserLiked
        });
        return;
      }

      var normalizedCurrentUser = _objectSpread(_objectSpread({}, currentUser), {}, {
        id: Number(currentUser.id)
      }); // Compute new state first so we can use it for both local state and parent callback


      var newState = (0, _likeStateUtils.updateLikedByState)(this.state.likedBy, this.state.topLikedBy, normalizedCurrentUser, hasCurrentUserLiked); // Update local state

      this.setState(newState); // Propagate to parent to persist state across collapse/expand cycles

      if (onLikeUpdate && privateReplyId) {
        onLikeUpdate(privateReplyId, newState.likedBy);
      }

      window.app.events.commands.execute("post:like:".concat(privateReplyId), {
        currentUserHasLiked: hasCurrentUserLiked
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          hasCurrentUserLiked = _this$state.hasCurrentUserLiked,
          likedBy = _this$state.likedBy,
          topLikedBy = _this$state.topLikedBy;
      var _this$props3 = this.props,
          publicId = _this$props3.publicId,
          userSubscribed = _this$props3.userSubscribed,
          currentUser = _this$props3.currentUser,
          showFollow = _this$props3.showFollow,
          showSocialShare = _this$props3.showSocialShare,
          onEditorClick = _this$props3.onEditorClick,
          showReplyAction = _this$props3.showReplyAction,
          replyCount = _this$props3.replyCount,
          isExpanded = _this$props3.isExpanded,
          onToggleReplies = _this$props3.onToggleReplies,
          _this$props3$showVote = _this$props3.showVotes,
          showVotes = _this$props3$showVote === void 0 ? false : _this$props3$showVote,
          contentType = _this$props3.contentType,
          _this$props3$canMarkB = _this$props3.canMarkBestAnswer,
          canMarkBestAnswer = _this$props3$canMarkB === void 0 ? false : _this$props3$canMarkB,
          _this$props3$isBestAn = _this$props3.isBestAnswer,
          isBestAnswer = _this$props3$isBestAn === void 0 ? false : _this$props3$isBestAn,
          onMarkBestAnswer = _this$props3.onMarkBestAnswer;
      var showTopLikedBy = likedBy && likedBy.length > 0;
      var isGuestUser = !currentUser.id;
      var showReplyButton = isGuestUser || showReplyAction && !!onEditorClick;
      var privateReplyId = this.props.privateReplyId;
      var isReply = !!privateReplyId;

      var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

      var isBugContent = (0, _contentType.isConversation)(contentType) && isBugContentTypeEnabled && !isReply;
      var displayVotes = showVotes || isBugContent;
      return (0, _preact.h)("div", {
        className: "topic-footer"
      }, (0, _preact.h)("div", {
        className: "topic-footer__actions"
      }, replyCount && onToggleReplies && (0, _preact.h)(_SubtleButton.default, {
        size: "medium",
        isSelected: isExpanded,
        className: (0, _classnames.default)('expand-collapse-button', 'tooltip-trigger', 'js-tooltip-trigger'),
        "data-qa": "expand-collapse-replies",
        onClick: onToggleReplies,
        startIcon: isExpanded ? (0, _preact.h)(_ExpandCircleUp.default, {
          width: 16,
          height: 16
        }) : (0, _preact.h)(_ExpandCircle.default, {
          width: 16,
          height: 16
        }),
        title: (0, _preact.h)(_phrase.default, {
          p: "{n} Reply|{n} Replies",
          count: {
            n: replyCount.toString()
          }
        }, function (translatedReplyCount) {
          return (0, _preact.h)("span", {
            "data-reply-count": replyCount === null || replyCount === void 0 ? void 0 : replyCount.toString()
          }, (0, _preact.h)("span", null, translatedReplyCount));
        })
      }), (0, _preact.h)(_SubtleButton.default, {
        size: "medium",
        isSelected: hasCurrentUserLiked,
        className: "action-btn--like ".concat(hasCurrentUserLiked ? 'action-btn--liked' : ''),
        "data-qa": "threaded-like-button",
        onClick: /*#__PURE__*/function () {
          var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(e) {
            return _regenerator.default.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return _this2.onLikeClick(e, isGuestUser);

                  case 2:
                    return _context3.abrupt("return", _context3.sent);

                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x4) {
            return _ref2.apply(this, arguments);
          };
        }(),
        startIcon: displayVotes ? (0, _preact.h)(_Upvote.default, {
          width: 16,
          height: 16
        }) : (0, _preact.h)(_ThumbUp.default, {
          width: 16,
          height: 16
        }),
        title: displayVotes ? (0, _preact.h)(_phrase.default, {
          m: "Forum",
          key: hasCurrentUserLiked ? 'upvoted' : 'upvote',
          p: hasCurrentUserLiked ? 'upvoted' : 'upvote'
        }) : (0, _preact.h)(_phrase.default, {
          m: "Common",
          key: hasCurrentUserLiked ? 'liked' : 'like',
          p: hasCurrentUserLiked ? 'liked' : 'like'
        })
      }), showTopLikedBy && (0, _preact.h)(_TopLikedBy.default, {
        likedBy: likedBy,
        topLikedBy: topLikedBy
      }), showReplyButton && (0, _preact.h)(_SubtleButton.default, {
        size: "medium",
        className: "action-btn--reply",
        "data-qa": "threaded-reply-button",
        onClick: function onClick(e) {
          e.preventDefault();

          if (isGuestUser) {
            (0, _actionService.showLoginModal)();
          } else {
            onEditorClick === null || onEditorClick === void 0 ? void 0 : onEditorClick();
          }
        },
        startIcon: (0, _preact.h)(_Comment.default, {
          width: 16,
          height: 16
        }),
        title: (0, _preact.h)(_phrase.default, {
          m: "Forum",
          p: "Reply"
        })
      }), canMarkBestAnswer && onMarkBestAnswer && (0, _preact.h)(_SubtleButton.default, {
        size: "medium",
        className: "action-btn--best-answer ".concat(isBestAnswer ? 'action-btn--best-answer-selected' : ''),
        "data-qa": "threaded-best-answer-button",
        onClick: onMarkBestAnswer,
        startIcon: isBestAnswer ? (0, _preact.h)(_CheckInCircleOff.default, {
          width: 16,
          height: 16
        }) : (0, _preact.h)(_CheckInCircle.default, {
          width: 16,
          height: 16
        }),
        title: (0, _preact.h)("span", {
          className: "post__action-link__text"
        }, (0, _preact.h)(_phrase.default, {
          p: isBestAnswer ? 'unmark.answer' : 'Best answer'
        }))
      }), showFollow && (0, _preact.h)(_Actions.Follow, {
        id: publicId,
        isGuestUser: isGuestUser,
        isSubscribed: userSubscribed
      }), showSocialShare && (0, _preact.h)(_Actions.Share, null)));
    }
  }]);
  return TopicFooter;
}(_preact.Component);

(0, _defineProperty2.default)(TopicFooter, "showLoginModal", function (e) {
  e.preventDefault();
  window.dispatchEvent(new CustomEvent('GuestUserAction'));
});
var _default = TopicFooter;
exports.default = _default;